import React, {useEffect, useState} from 'react';
import './styles.scss';
import * as Yup from 'yup';
import {functionalitiesAliasMap, strings} from '../../../../util/strings';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {Row} from '../../../../components/layout';
import * as fonts from '../../../../util/fonts';
import {
  uriGetUserConsents,
  uriGetWithdrawConsent,
  uriPostConsentReceipts,
} from '../../../../api/endpoints';
import {addToWizard, setWizard} from '../../../../store/actions';
import {Link} from 'react-router-dom';
import AppFormCheckboxField from './../../../../components/forms/AppFormCheckboxField';
import MyProfilePopup from './../../../register/communications/myProfile-popup/index';
import moment from 'moment';
import ErrorPopup from './../../error-popup/ErrorPopup';
import HealthDataPopup from './../../health-data-popup';
import {get, post} from '../../../../api/api';
import {AppForm} from '../../../../components/forms';
import {ITenant} from '../../../../App';

interface AdvanceCareTabProps {
  user: any;
  titular: any;
  selectedBu: any;
  availableBus: any;
  wizard: any;
  busFuncMap: any;
  busFuncMapDefault: any;
  tenant: ITenant;
  buStyles: any;
  setWizard(value: any): void;
  addToWizard(value: any): void;
  labels: typeof strings.pt.register;
  labelsPermissions: typeof strings.pt.permissions;
  oneTrust: typeof strings.pt.oneTrust;
  purposes: any;
}

const validationSchema = Yup.object().shape({
  termsAccepted: Yup.boolean().required(),
  privacyPolicyAccepted: Yup.boolean().required(),
});

function AdvanceCareTab({
  user,
  selectedBu,
  availableBus,
  busFuncMap,
  busFuncMapDefault,
  tenant,
  labels,
  labelsPermissions,
  wizard,
  buStyles,
  titular,
  setWizard,
  purposes,
  addToWizard,
  oneTrust,
}: AdvanceCareTabProps) {
  const [marketingCommunications, setMarketingCommunications] = useState(false);
  const [marketingConsentDate, setMarketingConsentDate] = useState('');
  const [marketingConsentLabel, setMarketingConsentLabel] = useState('');

  const [healthPrevention, setHealthPrevention] = useState(false);
  const [healthPreventionDate, setHealthPreventionDate] = useState('');
  const [healthPreventionLabel, setHealthPreventionLabel] = useState('');

  //adv+ consent to be removed, kept for reference for further testing
  // const [healthData, setHealthData] = useState(false);
  // const [healthDataDate, setHealthDataDate] = useState('');
  // const [healthDataLabel, setHealthDataLabel] = useState('');
  const [showWarningModal, setShowWarningModal] = useState(false);

  const [showOnlineClinic, setShowOnlineClinic] = useState(false);
  const [onlineClinic, setOnlineClinic] = useState(false);
  const [onlineClinicDate, setOnlineClinicDate] = useState('');
  const [onlineClinicLabel, setOnlineClinicLabel] = useState('');

  const [showError, setShowError] = useState(false);
  const [showMyProfile, setShowMyProfile] = useState(false);

  const [oneTrustIsVisible, setOneTrustIsVisible] = useState(
    busFuncMapDefault?.[functionalitiesAliasMap.oneTrust],
  );

  const [permissionsLabels, setPermissionsLabels] = useState({
    ...strings.pt.permissions,
    ...labels,
  });

  const featureName = 'Permissions-AdvancecareTab';

  const refresh = () => {
    window.location.reload();
  };

  useEffect(() => {
    oneTrustIsVisible && getPurposes();
    busFuncMap[selectedBu.buId]?.map((func: any) => {
      if (func.activa && 'Os meus Serviços' === func.displayText) {
        return busFuncMap[selectedBu.buId]?.map((func: any) => {
          if (func.activa && 'Consulta Online' === func.displayText) {
            setShowOnlineClinic(true);
          }
        });
      }
    });
  }, [selectedBu.memId]);

  const dateToString = (date: any, lang = 'pt') => {
    let string = moment(date).locale(lang).format('L');
    string = string.replace(/(\/)/g, '.');
    return string;
  };

  const getConsentedPlatform = (id: any) => {
    if (id === oneTrust.idCollectionPointMyAdv) {
      return labelsPermissions.permissions_myAdv;
    } else if (id === oneTrust.idCollectionPointADVPlus) {
      return labelsPermissions.permissions_advplus_title;
    }
    return '';
  };

  const getPurposes = async () => {
    if (!oneTrustIsVisible) {
      setShowError(true);
      return;
    }
    try {
      let consents: any = await get(
        uriGetUserConsents(user.nif),
        false,
        0,
        featureName,
      );
      consents?.data?.items[0].purposes.forEach((element: any) => {
        if (element.id === oneTrust.purposeMarketingComunications) {
          if (element.status === 'ACTIVE') {
            setMarketingCommunications(true);
            setMarketingConsentDate(dateToString(element.consentDate));
            setMarketingConsentLabel(
              getConsentedPlatform(element.lastTransactionCollectionPointId),
            );
          } else {
            setMarketingCommunications(false);
          }
        } else if (element.id === oneTrust.purposeHealthPrevention) {
          if (element.status === 'ACTIVE') {
            setHealthPrevention(true);
            setHealthPreventionDate(dateToString(element.consentDate));
            setHealthPreventionLabel(
              getConsentedPlatform(element.lastTransactionCollectionPointId),
            );
          } else {
            setHealthPrevention(false);
          }
        }
        // else if (element.id === oneTrust.purposeHealthData) {
        //   if (element.status === 'ACTIVE') {
        //     setHealthData(true);
        //     setHealthDataDate(dateToString(element.consentDate));
        //     setHealthDataLabel(
        //       getConsentedPlatform(element.lastTransactionCollectionPointId)
        //     );
        //   } else {
        //     setHealthData(false);
        //   }
        // }
        else if (element.id === oneTrust.porpose_clinic_consentimento) {
          if (element.status === 'ACTIVE') {
            setOnlineClinic(true);
            setOnlineClinicDate(dateToString(element.consentDate));
            setOnlineClinicLabel(
              getConsentedPlatform(element.lastTransactionCollectionPointId),
            );
          } else {
            setOnlineClinic(false);
          }
        }
      });
    } catch (e: any) {}
  };

  const marketingCommunicationChanged = async () => {
    if (!oneTrustIsVisible) {
      setShowError(true);
      return;
    }
    try {
      let consents: any = await get(
        uriGetUserConsents(user.nif),
        false,
        0,
        featureName,
      );
      if (
        consents?.data?.items[0].purposes.find(
          (purpose: any) =>
            purpose.id === oneTrust.purposeMarketingComunications &&
            purpose.status === 'ACTIVE',
        )
      ) {
        try {
          const response: any = await post(
            uriGetWithdrawConsent(
              user.nif,
              oneTrust.purposeMarketingComunications,
            ),
            {},
            false,
            featureName,
          );
        } catch (e: any) {
          setShowError(true);
        } finally {
          oneTrustIsVisible && (await getPurposes());
        }
      } else {
        const nif = user.nif;
        const token = oneTrust.tokenMyAdv;
        const body = JSON.stringify({
          identifier: nif,
          test: true,
          requestInformation: token,
          purposes: [{Id: oneTrust.purposeMarketingComunications}],
        });

        try {
          oneTrustIsVisible &&
            (await post(uriPostConsentReceipts(), body, false, featureName));
        } catch (e: any) {
        } finally {
          oneTrustIsVisible && (await getPurposes());
        }
      }
    } catch (e: any) {
      setShowError(true);
    }
    oneTrustIsVisible && (await getPurposes());
  };

  const onlineClinicChanged = async () => {
    if (!oneTrustIsVisible) {
      setShowError(true);
      return;
    }
    try {
      let consents: any = await get(
        uriGetUserConsents(user.nif),
        false,
        0,
        featureName,
      );
      if (
        consents?.data?.items[0].purposes.find(
          (purpose: any) =>
            purpose.id === oneTrust.porpose_clinic_consentimento &&
            purpose.status === 'ACTIVE',
        )
      ) {
        try {
          const response: any = await post(
            uriGetWithdrawConsent(
              user.nif,
              oneTrust.porpose_clinic_consentimento,
            ),
            {},
            false,
            featureName,
          );
        } catch (e: any) {
          setShowError(true);
        } finally {
          oneTrustIsVisible && (await getPurposes());
        }
      } else {
        const nif = user.nif;
        const token = oneTrust.tokenMyAdv;
        const body = JSON.stringify({
          identifier: nif,
          test: true,
          requestInformation: token,
          purposes: [{Id: oneTrust.porpose_clinic_consentimento}],
        });
        try {
          oneTrustIsVisible &&
            (await post(uriPostConsentReceipts(), body, false, featureName));
        } catch (e: any) {
        } finally {
          oneTrustIsVisible && (await getPurposes());
        }
      }
    } catch (e: any) {}
    oneTrustIsVisible && (await getPurposes());
  };

  const healthPreventionChanged = async () => {
    if (!oneTrustIsVisible) {
      setShowError(true);
      return;
    }
    try {
      let consents: any = await get(
        uriGetUserConsents(user.nif),
        false,
        0,
        featureName,
      );
      if (
        consents?.data?.items[0].purposes.find(
          (purpose: any) =>
            purpose.id === oneTrust.purposeHealthPrevention &&
            purpose.status === 'ACTIVE',
        )
      ) {
        try {
          const response: any = await post(
            uriGetWithdrawConsent(user.nif, oneTrust.purposeHealthPrevention),
            {},
            false,
            featureName,
          );
        } catch (e: any) {
          setShowError(true);
        } finally {
          oneTrustIsVisible && (await getPurposes());
        }
      } else {
        const nif = user.nif;
        const token = oneTrust.tokenMyAdv;
        const body = JSON.stringify({
          identifier: nif,
          test: true,
          requestInformation: token,
          purposes: [{Id: oneTrust.purposeHealthPrevention}],
        });
        try {
          oneTrustIsVisible &&
            (await post(uriPostConsentReceipts(), body, false, featureName));
        } catch (e: any) {
        } finally {
          oneTrustIsVisible && (await getPurposes());
        }
      }
    } catch (e: any) {}
    oneTrustIsVisible && (await getPurposes());
  };

  // const healthDataWithdraw = async () => {
  //   if (!oneTrustIsVisible) {
  //     setShowError(true);
  //     return;
  //   }
  //   try {
  //     let consents: any = await get(
  //       uriGetUserConsents(user.nif),
  //       false,
  //       0,
  //       featureName,
  //     );
  //     if (
  //       consents?.data?.items[0].purposes.find(
  //         (purpose: any) =>
  //           purpose.id === oneTrust.purposeHealthData &&
  //           purpose.status === 'ACTIVE',
  //       )
  //     ) {
  //       try {
  //         const response: any = await post(
  //           uriGetWithdrawConsent(user.nif, oneTrust.purposeHealthData),
  //           {},
  //           false,
  //           featureName,
  //         );
  //       } catch (e: any) {
  //         setShowError(true);
  //       } finally {
  //         oneTrustIsVisible && (await getPurposes());
  //       }
  //     }
  //   } catch (e: any) {}
  //   oneTrustIsVisible && (await getPurposes());
  // };

  return (
    <div>
      <Row className="tab-panel-row">
        <div className="permissions-tab-panel">
          <AppForm
            className="communications-form-container"
            initialValues={{}}
            validationSchema={validationSchema}
            onSubmit={async (values) => {}}>
            <Row className="advance-care-tab-subject-title">
              <p
                style={{...fonts.ML}}
                className="register-before-continue-subtitle1">
                {labels.register_beforeContinueSubtitle1}
              </p>
            </Row>
            <Row className="advance-care-tab-checkbox">
              <AppFormCheckboxField
                showErrorMessage
                purposeId={oneTrust.purposeMarketingComunications}
                name="marketingCommunication"
                defaultColor={false}
                value={marketingCommunications}
                onChange={() => marketingCommunicationChanged()}
                label={
                  <label style={{...fonts.SM, ...fonts.Medium}}>
                    {labels.register_beforeContinueCheckbox1Text}{' '}
                    <Link
                      className="communications-anchor"
                      style={{color: buStyles.primary}}
                      to="#"
                      onClick={() => setShowMyProfile(true)}>
                      {labels.register_beforeContinueCheckbox1Link}
                    </Link>
                    <Row className="advance-care-tab-authorized-row">
                      {marketingCommunications && (
                        <p style={{...fonts.SM, ...fonts.Bold}}>
                          {labelsPermissions.permissions_allowed}{' '}
                          {marketingConsentDate}{' '}
                          {labelsPermissions.permissions_where}{' '}
                          {marketingConsentLabel}
                        </p>
                      )}
                    </Row>
                  </label>
                }
              />
            </Row>

            <div>
              <MyProfilePopup
                show={showMyProfile}
                setShowModal={setShowMyProfile}
                strings={labels}
              />
            </div>
            <Row className="advance-care-tab-subject-title">
              <p
                style={{...fonts.ML}}
                className="register-before-continue-subtitle2">
                {labels.register_beforeContinueSubtitle2}
              </p>
            </Row>
            <Row className="advance-care-tab-checkbox">
              <AppFormCheckboxField
                showErrorMessage
                purposeId={oneTrust.purposeHealthPrevention}
                name="acceptedTermsAndConditions"
                defaultColor={false}
                onChange={() => healthPreventionChanged()}
                value={healthPrevention}
                label={
                  <label style={{...fonts.SM, ...fonts.Medium}}>
                    {labels.register_beforeContinueCheckbox2Text1}
                    <Link
                      className="communications-anchor"
                      style={{color: buStyles.primary}}
                      to="#"
                      onClick={() => setShowMyProfile(true)}>
                      {labels.register_beforeContinueCheckbox2Link}
                    </Link>
                    {labels.register_beforeContinueCheckbox2Text2}

                    <Row className="advance-care-tab-authorized-row">
                      {healthPrevention && (
                        <p style={{...fonts.SM, ...fonts.Bold}}>
                          {labelsPermissions.permissions_allowed}{' '}
                          {healthPreventionDate}{' '}
                          {labelsPermissions.permissions_where}{' '}
                          {healthPreventionLabel}
                        </p>
                      )}
                    </Row>
                  </label>
                }
              />
              <ErrorPopup
                show={showError}
                setShowModal={setShowError}
                refresh={refresh}
              />
            </Row>
            {showOnlineClinic &&
              oneTrust.porpose_clinic_consentimento_show === 'true' && (
                <>
                  <Row className="advance-care-tab-subject-title">
                    <p
                      style={{...fonts.ML}}
                      className="register-before-continue-subtitle2">
                      {permissionsLabels.permissions_clinic_title}
                    </p>
                  </Row>
                  <Row className="advance-care-tab-checkbox">
                    <AppFormCheckboxField
                      showErrorMessage
                      purposeId={oneTrust.porpose_clinic_consentimento}
                      name="clinic"
                      onChange={() => onlineClinicChanged()}
                      defaultColor={false}
                      value={onlineClinic}
                      label={
                        <label style={{...fonts.SM, ...fonts.Medium}}>
                          {permissionsLabels.permissions_clinic_checkbox_text}{' '}
                          <a
                            className="communications-anchor"
                            style={{color: buStyles.primary}}
                            target="_blank"
                            href={
                              labels.permissions_TermosCondiçõesAdvPlusLink
                            }>
                            {
                              permissionsLabels.permissions_clickOnAuthorizationThirdParties
                            }
                          </a>
                          <Row className="advance-care-tab-authorized-row">
                            {onlineClinic && (
                              <p style={{...fonts.SM, ...fonts.Bold}}>
                                {labelsPermissions.permissions_allowed}{' '}
                                {onlineClinicDate}{' '}
                                {labelsPermissions.permissions_where}{' '}
                                {onlineClinicLabel}
                              </p>
                            )}
                          </Row>
                        </label>
                      }
                    />
                  </Row>
                </>
              )}
            {/* {healthData && (
              <>
                <Row className="advance-care-tab-subject-title">
                  <p
                    style={{...fonts.ML}}
                    className="register-before-continue-subtitle2">
                    {labels.permissions_titleHealthData}
                  </p>
                </Row>
                <Row className="advance-care-tab-checkbox">
                  <AppFormCheckboxField
                    showErrorMessage
                    purposeId={oneTrust.purposeHealthData}
                    name="healthData"
                    onChange={() => setShowWarningModal(true)}
                    defaultColor={false}
                    value={healthData}
                    label={
                      <label style={{...fonts.SM, ...fonts.Medium}}>
                        {labels.permissions_descriptionHealthData}{' '}
                        <a
                          className="communications-anchor"
                          style={{color: buStyles.primary}}
                          target="_blank"
                          href={labels.permissions_TermosCondiçõesAdvPlusLink}>
                          {labels.permissions_moreInfoAdvPlus}
                        </a>
                        <Row className="advance-care-tab-authorized-row">
                          {healthData && (
                            <p style={{...fonts.SM, ...fonts.Bold}}>
                              {labelsPermissions.permissions_allowed}{' '}
                              {healthDataDate}{' '}
                              {labelsPermissions.permissions_where}{' '}
                              {healthDataLabel}
                            </p>
                          )}
                        </Row>
                      </label>
                    }
                  />
                </Row>
              </>
            )} */}
            {/* <HealthDataPopup
              show={showWarningModal}
              setShowModal={setShowWarningModal}
              withdraw={healthDataWithdraw}
              refresh={refresh}
            /> */}
          </AppForm>
        </div>
      </Row>
    </div>
  );
}

const mapStateToProps = ({
  selectedBu,
  user,
  strings,
  stringsDefault,
  wizard,
  availableBus,
  globalStyles,
  titular,
  busFuncMap,
  purposes,
  busFuncMapDefault,
  tenant,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  availableBus: availableBus.value,
  labels: strings.value.pt.register,
  labelsPermissions: strings.value.pt.permissions,
  oneTrust: stringsDefault.value.pt.oneTrust,
  wizard: wizard.value,
  buStyles: globalStyles.value,
  titular: titular.value,
  purposes: purposes.value,
  busFuncMap: busFuncMap.value,
  busFuncMapDefault: busFuncMapDefault.value,
  tenant: tenant.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(AdvanceCareTab),
);
